// src/hooks/useCounter.js
// Animated counter with eased cubic out

import { useState, useEffect } from 'react';

const useCounter = (target, isActive, duration = 1500) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isActive) return;

    const startTime = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(eased * target));
      if (progress < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }, [target, isActive, duration]);

  return count;
};

export default useCounter;